module.exports = __webpack_public_path__ + "static/media/ic_crop_img.496bdaa1.svg";